import React, { useEffect, useState } from 'react';
import './RolesAndPermission.scss'
import { MdEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import Loader from '../../component/loaderComponent/Loader';
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";
import NodataFound from '../../component/NodataFound';
import Paginations from '../../component/Pagination/PgmTextField';
import { useNavigate } from 'react-router-dom';
import { deleteRoleAction } from '../../actions/permissionAction';
import { useDispatch } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import DeletePopup from '../../component/DeletePopup/DeletePopup';
import { HTTP_STATUS } from '../../constants/httpstatus/HttpsStatus';
import { hasAnyPermission, hasPermission } from '../../utils/permissionUtils';
import { PERMISSIONS } from '../../constants/permissions/Permissions';

const RolesAndPermission = ({ roles: initialRoles, isLoading, onRolesUpdate }) => {

    const { i18n, t } = useTranslation();
    const language = Cookies.get("language");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [roles, setRoles] = useState(initialRoles);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);

    useEffect(() => {
        setRoles(initialRoles);
    }, [initialRoles]);

    useEffect(() => {
        handleChangeLanguage(language);
    }, []);

    const handleDelete = async () => {
        if (!selectedRole) return;

        const { status, message } = await dispatch(deleteRoleAction(selectedRole.id));

        if (status === HTTP_STATUS.SUCCESS) {
            const updatedRoles = roles.filter((role) => role.id !== selectedRole.id);
            setRoles(updatedRoles);
            if (typeof onRolesUpdate === 'function') {
                onRolesUpdate(updatedRoles);
            }
            NotificationManager.success(message);
        } else {
            return;
        }
        setIsPopupOpen(false);
    };

    const handleChangeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    const handleEdit = (roleId) => {
        const selectedRole = roles.find(role => role.id === roleId);
        navigate(`/edit_role/${roleId}`, { state: { role: selectedRole, roles } })
    };

    const openDeletePopup = (user) => {
        setSelectedRole(user);
        setIsPopupOpen(true);
    };

    return (
        <div>
            <div className='role-table'>
                {isLoading ? (
                    <Loader />
                ) : roles.length === 0 ? (
                    <NodataFound message={t('RolesAndPermission.noData')} />
                ) : (
                    <table>
                        <thead>
                            <tr>
                                <th>{t('common.sNo')}</th>
                                <th className="role-name-column">{t('RolesAndPermission.roleName')}</th>
                                {hasAnyPermission([PERMISSIONS.CAN_VIEW_ROLE_PERMISSION_DETAILS, PERMISSIONS.CAN_DELETE_ROLE_AND_PERMISSION]) && (
                                    <th>{t('common.action')}</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {roles.map((role, index) => (
                                <tr key={role.id}>
                                    <td>{index + 1}</td>
                                    <td className="role-name-column">{role?.role}</td>
                                    {hasAnyPermission([PERMISSIONS.CAN_VIEW_ROLE_PERMISSION_DETAILS, PERMISSIONS.CAN_DELETE_ROLE_AND_PERMISSION]) && (
                                        <td className='action-btn'>
                                            {hasPermission(PERMISSIONS.CAN_VIEW_ROLE_PERMISSION_DETAILS) && (
                                                <button className='edit-btn' onClick={() => handleEdit(role.id)}>
                                                    <MdEdit style={{ 'verticalAlign': 'middle' }} />
                                                </button>
                                            )}
                                            {hasPermission(PERMISSIONS.CAN_DELETE_ROLE_AND_PERMISSION) && (
                                                <button className='delete-btn' onClick={() => openDeletePopup(role)}>
                                                    <RiDeleteBin6Line style={{ 'verticalAlign': 'middle' }} />
                                                </button>
                                            )}
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <div className="pagination-comp">
                    <Paginations />
                </div>
            </div>
            <DeletePopup
                title={t('RolesAndPermission.deleteRole')}
                isOpen={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                onConfirm={handleDelete}
                message={t('RolesAndPermission.deleteRoleConfirmation')}
                t={t}
            />
        </div>
    )
}

export default RolesAndPermission